export const backendUrl = process.env.REACT_APP_CORE_BASE_URL;
export const portalBranding = process.env.REACT_APP_PORTAL_BRANDING;
export const displayStockLevels =
  process.env.REACT_APP_DISPLAY_STOCK_LEVELS === '1';
export const displayWebSku = process.env.REACT_APP_DISPLAY_WEB_SKU === '1';
